import request from '@/CommonDP/utils/request';
// 标准图框维护
export default {
  // 列表
  selectStandardFrameMaintenance(enterpriseId) {
    return request.get(
      `/standardFrameMaintenance/getStandardFrameFiles?enterpriseId=${enterpriseId}`
    );
  },
  // 修改
  updateStandardFrame(params) {
    return request
      .post(`/standardFrameMaintenance/updateStandardFrameFile`, params)
      .then((res) => res);
  },
  // 重命名
  renameStandardFrameFile(params) {
    return request
      .post(`/standardFrameMaintenance/renameStandardFrameFile`, params)
      .then((res) => res);
  },
  // 删除
  deleteStandardFrameFile(params) {
    return request.get(
      '/standardFrameMaintenance/deleteStandardFrameFile',
      { params }
    );
  },
  // 上传
  uploadStandardFrameFile(data) {
    return request.post(
      '/standardFrameMaintenance/uploadStandardFrameFile',
      data,
      { timeout: 0 }
    );
  },
  getStandardFrameDetails(params) {
    return request.get(
      '/standardFrameMaintenance/getStandardFrameDetails',
      { params }
    );
  },
  // 下载
  downloadStandardFrameFile(fileID) {
    return request({
      url: `/standardFrameMaintenance/downloadStandardFrameFile/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  },
  getDicContentList(dicCode) {
    return request.get(`/dic/getDicContentList?dicCode=${dicCode}`);
  }
};
